import React, { Component } from 'react'
import { AppContext } from '@lightspeed-invoicing/core-client/frontend'
import { FormattedMessage, FormattedNumber, injectIntl } from 'react-intl'
import { Link, Redirect } from 'react-router-dom'
import $ from 'jquery'
import LoadingSpinner from "../../common/spinner/loading.component.jsx"
import ActionButton from "../../common/button/actionbutton.component.jsx"
import Icon from "../../common/icon/icon.component.jsx";
import CustomerSelect from "../../customer/selection.component.jsx";
import moment from "moment";
import { SingleDatePicker } from "react-dates";
import PaymentTermSelect from '../../payment-term/locationselect.component.jsx';
import {INTEGRATION_KEY} from "../../state/integration/Constants";

class ImportSaleModal extends Component {

    constructor(props, context) {
        super(props, context);

        const dueDate = moment();
        this.state = {
            modalId: this.props.modalId || 'invoice-creation-modal',
            recurring: this.props.recurring || false,
            contactId: this.props.contactId || "",
            contactName:this.props.contactName || "",
            customerId:this.props.customerId || "",
            saleId:this.props.saleId || "",
            focused: false,
            dueDate: dueDate,
            sellerId: this.props.sellerId || AppContext.getUserLoggedIn().id,
            days: [7, 15, 30, 45],
            loading: false,
            hasPaymentTerms: false,
            paymentTermId: '',
            poNumber:"",
            hasEmpty:false,
        }
        this.handleCloseModal = this.handleCloseModal.bind(this)
        this.saveInvoice = this.saveInvoice.bind(this)
        this.handleFormChange = this.handleFormChange.bind(this)
        this.loadPaymentTerm = this.loadPaymentTerm.bind(this)
        this.loadCustomer = this.loadCustomer.bind(this)
    }

    componentDidMount() {
        $('#' + this.state.modalId).modal('show')
        this.setState({
            loading: true,
        })
      
        AppContext.getApiClient().get('/payment-terms').then(res => {
            this.setState({
                loading: false,
                hasPaymentTerms: res.data.length > 0,
            })
            const term = res.data.filter(t => t.attributes.isDefault)[0]
            if (this.state.contactId) {
                AppContext.getApiClient().get('/contacts/' + this.state.contactId).then(res => {
                    if (res.type === 'organizations') {
                        this.setState({
                            contactId: res.attributes.primaryContactId,
                        })
                        return AppContext.getApiClient().get('/contacts/' + res.attributes.primaryContactId)
                    } else {
                        return Promise.resolve(res)
                    }
                }).then(res => {
                    if (res.attributes && res.attributes.paymentTermId) {
                        this.setState({
                            loading: false,
                        })
                        this.loadPaymentTerm(res.attributes.paymentTermId)
                    } else if (term) {
                        this.loadPaymentTerm(term.id)
                    }
                })
            } else if (term) {
                this.loadPaymentTerm(term.id)
            }
        })
    }

    loadPaymentTerm(paymentTermId) {
        if (!paymentTermId) {
            this.setState({
                paymentTermId: paymentTermId,
            }, ()=> this.hasEmptyFields())
            return
        }
        AppContext.getApiClient().post('/payment-terms/' + paymentTermId + '/evaluate', {
            issuedDate: new Date().toISOString()
        }).then(res => {
            this.setState({
                paymentTermId: paymentTermId,
                dueDate: moment(res.attributes.dueDate),
            })
        })
    }

    loadCustomer(contactId) {
        if (!contactId) {
            this.setState({contactId: ""})
        }
        this.setState({
            contactId: contactId,
        })
        AppContext.getApiClient().get('/contacts/' + contactId).then(res => {
            if (res.attributes && res.attributes.paymentTermId) {
                this.setState({
                    loading: false,
                })
                this.loadPaymentTerm(res.attributes.paymentTermId)
            }
        })
    }

    handleCloseModal(event) {
        event.preventDefault()
        this.closeModal()
    }

    closeModal(invoiceId) {
        $('#' + this.state.modalId).modal('hide')
        if (this.props.onClose) {
            this.props.onClose(invoiceId)
        }
    }

    today() {
        const newDate = moment().toDate()
        newDate.setHours(0, 0, 0, 0)
        return newDate.toISOString()
    }


    saveInvoice(event) {
        event.preventDefault()
        
        AppContext.getApiClient().post('/invoices/single-import', {
            externalId: this.state.saleId,
            integrationKey: INTEGRATION_KEY.LIGHTSPEED_RETAIL,
            capturePayment: false,
            applyPayments:this.props.applyPayments,
            contactId:this.state.contactId,
            invoice: {
                paymentTermId: this.state.paymentTermId,
                poNumber: this.state.poNumber,
                dueDate:this.state.dueDate,
            }
        }).then(inv => {
            if (inv.error) {
                this.setState({
                    errorMessage: inv.error.message
                })
                return
            }else{
                this.closeModal(inv.id)
            }
           
        })
       
    }

   
    handleFormChange(event) {
        const value = event.target.value
        this.setState({
            poNumber:value
        })
    }

    changeDueDate(nbDays) {
        return function (e) {
            e.preventDefault()
            this.setState({
                dueDate: moment().add(nbDays, 'days')
            })
        }.bind(this)
    }

    modalTitle() {
        return <FormattedMessage
            id="invoice.modal.creation.title"
            defaultMessage="Create an invoice"
        />
    }

    
   

    render() {
        let content = <p />
        if (this.state.loading) {
            content = <LoadingSpinner className="py-2" />
        }
           
        return (
            <form className="needs-validation" noValidate id="work-order-form-creation-modal">
                <div className="modal"
                    id={this.state.modalId}
                    role="dialog"
                    aria-labelledby={this.state.modalId + "Label"}
                    aria-hidden="true"
                    data-backdrop="static"
                    data-keyboard="false"
                >
                    <div className="modal-dialog "  role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <div className="modal-title h5" id={this.state.modalId + "Label"}>
                                    {this.modalTitle()}
                                </div>
                            </div>
                            <div className="modal-body py-0">
                                
                                {!this.state.loading ? <div className="container-fluid">
                                    <div className="form-group row mt-3">
                                        <label htmlFor="contactId" className="col-lg-3 col-12 col-form-label">
                                            <FormattedMessage
                                                    id="common.invoice.modal.customer_label"
                                                    defaultMessage="Invoice to"
                                                />
                                        </label>
                                        <div className="col-lg-9 col-12">
                                            {this.state.contactId && this.state.contactName?
                                                <Link to={'/contacts/' + this.state.contactId+ '/details'} onClick={()=>{
                                                    this.handleCloseModal()
                                                    return <Redirect to={'/contacts/' + this.state.contactId+ '/details'}/>
                                                }}>
                                                    {this.state.contactName}
                                                </Link>:
                                                this.state.customerId?
                                                this.state.contactName:
                                                <CustomerSelect
                                                    id={'contactId'}
                                                    contactType={'persons'}
                                                    value={this.state.contactId}
                                                    onChange={this.loadCustomer}
                                                />
                                            }
                                        </div>
                                    </div>
                                    <div className="form-group row mb-2">
                                        <label className="col-lg-3 col-12 col-form-label">
                                            <FormattedMessage
                                                id= 'common.rich_text.merge_fields.po_number_label'
                                                defaultMessage= 'PO Number'
                                            />
                                        </label>
                                        <div className="col-lg-9 col-12">
                                            <input name="poNumber" id="poNumber" onChange={this.handleFormChange} value={this.state.poNumber} className="form-control" required autoFocus />
                                        </div>
                                    </div>
                                    {this.state.hasPaymentTerms? 
                                    <div className="form-group row mb-2">
                                        <label className="col-lg-3 col-12 col-form-label">
                                            <FormattedMessage
                                                id="common.invoice.modal.payment_terms_label"
                                                defaultMessage="Payment term"
                                            />
                                        </label>
                                        <div className="col-lg-9 col-12">
                                            <div className={'mb-2'}>
                                                <PaymentTermSelect
                                                    value={this.state.paymentTermId}
                                                    onChange={this.loadPaymentTerm}
                                                />
                                            </div>
                                        </div>
                                    </div> : null}
                                    
                                    <div className="form-group row mb-0">
                                        <label htmlFor="dueDate" className="col-lg-3 col-12 col-form-label">
                                            <FormattedMessage
                                                id="common.invoice.modal.due_date_label"
                                                defaultMessage="Due date"
                                            />
                                        </label>
                                        <div className="col-lg-9 col-12">
                                            <div className={'mb-2'}>
                                                <SingleDatePicker
                                                    small
                                                    block
                                                    displayFormat="LL"
                                                    isOutsideRange={() => false}
                                                    focused={this.state.focused}
                                                    onDateChange={(date) => {
                                                        this.setState({
                                                            dueDate: date
                                                        })
                                                    }}
                                                    onFocusChange={({ focused }) => this.setState({ focused })}
                                                    date={this.state.dueDate}
                                                    numberOfMonths={1}
                                                    id={'dueDate'}
                                                />
                                            </div>
                                            {!this.state.hasPaymentTerms ? <div className={'mb-0'}>
                                                {this.state.days.map(d => {
                                                    return <button key={d} className={'btn btn-sm btn-light mr-2'} onClick={this.changeDueDate(d)}>
                                                        <Icon value={'calendar-check'} className={'mr-1'} />
                                                        <FormattedMessage
                                                            id="common.invoice.modal.nb_days"
                                                            defaultMessage="{nbDays} days"
                                                            values={{
                                                                nbDays: d
                                                            }}
                                                        />
                                                    </button>
                                                })}
                                            </div> : null}
                                        </div>
                                    </div>
                                    {content}
                                </div> 
                                : 
                                <div className="container-fluid">
                                    <LoadingSpinner className="py-2" />
                                </div>}
                            </div>


                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={this.handleCloseModal}>
                                    <FormattedMessage
                                        id="common.invoice.modal.close_btn"
                                        defaultMessage="Close"
                                    />
                                </button>
                                    <ActionButton disabled={(!this.state.contactId && !this.state.customerId)} className="btn btn-primary" onClick={this.saveInvoice}>
                                        <Icon value={"invoice"} className={"mr-1"} />
                                        <FormattedMessage
                                            id="common.invoice.modal.confirm_btn"
                                            defaultMessage="Create invoice"
                                        />
                                    </ActionButton>
                            </div>


                        </div>
                    </div>
                </div>
            </form>
        );
    }
}

export default injectIntl(ImportSaleModal)


// WEBPACK FOOTER //
// ./src/invoice/lightspeed/importsalemodal.component.jsx